/* JS */
import "@js/parts/lazyloading";
import initJerseyAttractionsSwiper from "@/js/components/jersey-attractions";
import initLatestArticlesSwiper from "./components/latest";

/* CSS */
import "@js/parts/css";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

Alpine.plugin(collapse);

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}

document.addEventListener("DOMContentLoaded", initJerseyAttractionsSwiper);
document.addEventListener("DOMContentLoaded", initLatestArticlesSwiper);
document.addEventListener("DOMContentLoaded", function () {
  const tempEl = document.getElementById("weather-temp");
  const celBtn = document.getElementById("cel-btn");
  const farBtn = document.getElementById("far-btn");
  const lowEl = document.querySelector("span.text-orange[data-weather-low]");
  const highEl = document.querySelector("span.text-orange[data-weather-high]");
  if (!tempEl || !celBtn || !farBtn) return;

  // Extract value and unit from initial content
  const tempMatch = tempEl.textContent.match(/([-+]?\d*\.?\d+)(.*)/);
  const celsius = tempMatch ? parseFloat(tempMatch[1]) : 0;
  const unitC = tempMatch ? tempMatch[2].trim() : "°C";
  const unitF = "°F";

  // For low/high, extract initial values if present
  let lowC = null,
    highC = null;
  if (lowEl) {
    const lowMatch = lowEl.textContent.match(/([-+]?\d*\.?\d+)/);
    lowC = lowMatch ? parseFloat(lowMatch[1]) : null;
  }
  if (highEl) {
    const highMatch = highEl.textContent.match(/([-+]?\d*\.?\d+)/);
    highC = highMatch ? parseFloat(highMatch[1]) : null;
  }

  function setCelsius() {
    tempEl.textContent = celsius.toFixed(1) + unitC;
    if (lowEl && lowC !== null) lowEl.textContent = lowC.toFixed(1) + unitC;
    if (highEl && highC !== null) highEl.textContent = highC.toFixed(1) + unitC;
    celBtn.classList.remove("text-gray-300");
    celBtn.classList.add("text-gray-500");
    farBtn.classList.remove("text-gray-500");
    farBtn.classList.add("text-gray-300");
  }

  function setFahrenheit() {
    const fahrenheit = (celsius * 9) / 5 + 32;
    tempEl.textContent = fahrenheit.toFixed(1) + unitF;
    if (lowEl && lowC !== null)
      lowEl.textContent = ((lowC * 9) / 5 + 32).toFixed(1) + unitF;
    if (highEl && highC !== null)
      highEl.textContent = ((highC * 9) / 5 + 32).toFixed(1) + unitF;
    farBtn.classList.remove("text-gray-300");
    farBtn.classList.add("text-gray-500");
    celBtn.classList.remove("text-gray-500");
    celBtn.classList.add("text-gray-300");
  }

  celBtn.addEventListener("click", setCelsius);
  farBtn.addEventListener("click", setFahrenheit);
});

/* init general swipers for the card sliders (could be multiple) */

document.querySelectorAll("[data-swiper]").forEach((el) => {
  const config = JSON.parse(el.dataset.swiper);

  // Clone the config so we can safely modify it
  const swiperConfig = { ...config };

  console.log(config);
  // Handle navigation bindings if present
  if (config.navigation) {
    swiperConfig.navigation = {
      nextEl: document.querySelector(config.navigation.nextEl),
      prevEl: document.querySelector(config.navigation.prevEl),
    };
  }
  console.log(swiperConfig);

  // Initialize Swiper with resolved DOM elements
  new Swiper(el, swiperConfig);
});

// Create the scroll reveal function that we can reuse
function applyScrollReveal(el, expression = "") {
  // Don't apply twice
  if (el.hasAttribute("data-scroll-reveal-applied")) {
    return;
  }

  el.setAttribute("data-scroll-reveal-applied", "true");
  el.classList.add("animate-out");

  const options = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  };

  const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("animate-in");
      entry.target.classList.remove("animate-out");

      // Fire stat count-up once per container
      if (!entry.target.dataset.statsAnimated) {
        runStatCountUp(entry.target);
        entry.target.dataset.statsAnimated = "1";
      }
    } else if (expression !== "once") {
      entry.target.classList.remove("animate-in");
      entry.target.classList.add("animate-out");
    }
  });
  }, options);

  observer.observe(el);
}

// Register the Alpine directive
Alpine.directive("scroll-reveal", (el, { expression }) => {
  applyScrollReveal(el, expression);
});

// --- Stat count-up when revealed ---
const runStatCountUp = (container) => {
  const numbers = container.querySelectorAll(".stat-number[data-count-target]");
  if (!numbers.length) return;

  const duration = 1200; // ms
  numbers.forEach((el) => {
    const target = parseFloat(el.dataset.countTarget);
    if (isNaN(target)) return;
    let start = null;

    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const value = Math.floor(progress * target);
      el.textContent = value.toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target.toLocaleString();
      }
    };

    requestAnimationFrame(step);
  });
};

// Apply scroll reveal to existing elements that Alpine might have missed
setTimeout(() => {
  const elements = document.querySelectorAll(
    "[x-scroll-reveal]:not([data-scroll-reveal-applied])"
  );

  elements.forEach((el, index) => {
    applyScrollReveal(el);
  });
}, 100);

// Watch for new elements being added to the DOM
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        // Element node
        // Check if the added node itself has x-scroll-reveal
        if (
          node.hasAttribute &&
          node.hasAttribute("x-scroll-reveal") &&
          !node.hasAttribute("data-scroll-reveal-applied")
        ) {
          applyScrollReveal(node);
        }

        // Check if any children have x-scroll-reveal
        const childElements = node.querySelectorAll
          ? node.querySelectorAll(
              "[x-scroll-reveal]:not([data-scroll-reveal-applied])"
            )
          : [];
        childElements.forEach((child) => {
          applyScrollReveal(child);
        });
      }
    });
  });
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener("alpine:init", () => {
  Alpine.store("nav", { menuOpen: false });
  Alpine.effect(() => {
    document.body.classList.toggle(
      "overflow-hidden",
      Alpine.store("nav").menuOpen
    );
  });
});

window.Alpine = Alpine;
Alpine.start();
